module.exports = "/static/assets/e103deb85b6f54309b24892f06817666.png";